import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { Invoice, InvoicesListViewModel } from "./invoicesList-viewModel"

export class InvoicesListView extends View<InvoicesListViewModel>{
    GetViewUniqueId(): string {
        return "V-6322F52B-A0BF-4E3C-BEB6-59B5EE5D0411"
    }
    loadHtml(): string {
        let element = require('./invoicesList.html').default;
        let style = require('./invoicesList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set invoices(v: ObservableArray<Invoice>) { this._invoices = v; } public get invoices(): ObservableArray<Invoice> { return this._invoices;} private _invoices: ObservableArray<Invoice>;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
}
